module.exports = __webpack_public_path__ + "static/map2-8218b27b39583114bb4e65ec146852f3.png";